import { getMerchantBusinessDetailHero } from '@assets/illustrations';
import { memo, useEffect, useState } from 'react';

const FALLBACK_HERO = getMerchantBusinessDetailHero();

const BusinessDetailHero = memo(({ src, alt }) => {
  const [imageSrc, setImageSrc] = useState(() => src || FALLBACK_HERO);

  useEffect(() => {
    setImageSrc(src || FALLBACK_HERO);
  }, [src]);

  return (
    <div className="relative h-[132px] w-full max-w-onboarding overflow-hidden md:h-[165px] desktop:h-[220px]">
      <img
        src={imageSrc}
        alt={alt}
        className="absolute inset-0 size-full max-w-none rounded object-cover md:rounded-[6px] desktop:rounded-lg"
        onError={() => {
          setImageSrc((current) => (current === FALLBACK_HERO ? current : FALLBACK_HERO));
        }}
      />
    </div>
  );
});

BusinessDetailHero.displayName = 'BusinessDetailHero';

export default BusinessDetailHero;
